import { FormGroup, FormControl, FormArray, AbstractControl } from '@angular/forms';

/* istanbul ignore next */
export function triggerFormValidation(formGroup) {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
          if (!control.valid) { control.markAsTouched({ onlySelf: true }); }
        } else if (control instanceof FormArray) {
          if (!control.valid) {
            control.controls.forEach(group => { triggerFormValidation(group); });
          }
        } else if (control instanceof FormGroup) {
          triggerFormValidation(control);
        }
    });
}
/* istanbul ignore next */
export function focusFirstInvalidField(formGroup) {

    Object.keys(formGroup.controls).some(fieldName => {
        const control = formGroup.get(fieldName);
        if (control instanceof FormControl && !control.valid && !control.disabled) {
          const elm = $('#' + fieldName);
          if (elm.length > 0) {
              $('html,body').animate({ scrollTop: elm.offset().top - 30 }, 'slow');
              elm.focus();

            return true;
          }
        } else if (control instanceof FormArray) {
          if (!control.valid) {
            control.controls.forEach((group: FormGroup) => {
              Object.keys(group.controls).some(fieldName => {
                const elm = $('.ng-invalid').filter('input, .ng-select');
                if (elm.length !== 0) {
                  elm[0].focus();
                  elm[0].scrollIntoView({ behavior: 'smooth' });
                }
                return true;
              });
             });
          }

        } else if (control instanceof FormGroup) {
          focusFirstInvalidField(control);
        }
    });
}

/* istanbul ignore next */
export function scrollToHeader() {
    setTimeout(() => {
        const elm = $('#form-header');
        if (elm.length > 0) { $('html,body').animate({ scrollTop: elm.offset().top - 20 }, 'slow'); }
    }, 250);
}
/* istanbul ignore next */
export function compareObjects(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
}
/* istanbul ignore next */
export function getFormValidators(_formGroup) {
    const formValidators = [];
    const recursiveFunc = (formGroup) => {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
              formValidators.push({ name: field, valid: control.valid, disabled: control.disabled,
                  required: hasRequiredField(control), value: control.value, errors: control.errors });
            } else if (control instanceof FormArray) {
              control.controls.forEach(group => { recursiveFunc(group); });
            } else if (control instanceof FormGroup) {
              recursiveFunc(control);
            }
        });
    };
    recursiveFunc(_formGroup);
    return formValidators;
}
/* istanbul ignore next */
export const hasRequiredField = (abstractControl: AbstractControl): boolean => {
    if (abstractControl.validator) {
        const validator = abstractControl.validator({} as AbstractControl);
        if (validator && validator.required) { return true; }
    }
    return false;
};


export function  phoneNumber(tel: any): string {
  let phone = '';
  const toString = String(tel),
    phoneNumber = toString.replace(/[^0-9]/g, ''),
    countArrayStr = phoneNumber.split(''),
    numberVar = countArrayStr.length,
    closeStr = countArrayStr.join('');
  if (numberVar === 10) {
    phone = closeStr.replace(/(\d{3})(\d{3})(\d{4})/, '$1$2$3');
    // Change number symbols here for numbers 10 digits in length. Just change the periods to what ever is needed.
  } else if (numberVar > 10) {
    const howMany = closeStr.length,
      subtract = 10 - howMany,
      phoneBeginning = closeStr.slice(0, subtract),
      phoneExtention = closeStr.slice(subtract),
      disX = 'x', // Change the extension symbol here
      phoneBeginningReplace = phoneBeginning.replace(
        /(\d{3})(\d{3})(\d{4})/,
        '$1.$2.$3'
      ), // Change number symbols here for numbers greater than 10 digits in length. Just change the periods and to what ever is needed.
      array = [phoneBeginningReplace, disX, phoneExtention];
    phone = array.join('');
  } else {
    phone = 'invalid number US number';
  }
  return phone;
}

export function isNullOrUndefined(object: any): boolean {
  return object === null || typeof object === undefined;
}
